module.exports = __webpack_public_path__ + "img/2560x1480-8.97e2b341.gif";